<template lang="pug">
	
	.political-presentation
		.wrap-text
			splited-text(ref="splitedText" :text="text")
		
		.badge.badge-1
			img(src="assets/images/badge.png")

		.badge.badge-2
			img(src="assets/images/badge.png")


</template>


<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import AssetsLoader from '../../../utils/assetsLoader.js'
	import Scrollable from '../../../abstracts/scrollable'
	import Globals from '~utils/Globals.js'

	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import SplitedText from '~components/splited-text.vue'
	
  @Component({
		name: 'PoliticalPresentation',
		props: [],
		components: { SplitedText},
		data : function () {
			return {
				text : ""
			}
		}
	})

	class PoliticalPresentation extends Scrollable {

		created () {
			this.text = this.translate('political.today')
		}
 
		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

			this.isResized = false
		}

		_dom () {
			this.$text = this.$el.querySelector('.wrap-text')
			this.$badge1 = this.$el.querySelector('.badge-1')
			this.$badge2 = this.$el.querySelector('.badge-2')
		}

		initTimeline () {
			super.initTimeline()

			const h = Globals.height

			this.tl.set(this.$badge1,{y:-120})
			this.tl.set(this.$badge2,{y:40})
			this.tl.to(this.$badge1,1,{y:120,ease:Power0.easeNone},0)
			this.tl.to(this.$badge2,1,{y:-60,ease:Power0.easeNone},0)
			this.tl.add(()=>{
				if(this.scroller.direction == 1 || this.isResized == false) {
					this.$refs.splitedText.animateIn()
				} else {
					this.$refs.splitedText.animateOut()
				}

				this.isResized = true
			}, Globals.height*.2 / (Globals.height + this.bounds.height))

		}

		raf (y) {
			super.raf(y)	
		}


		// _points () {

		// 	this.scroller.point('text.appear'+this._uid,{
		// 		position: this.bounds.top - window.innerHeight*.7,
		// 		direction: 1,
		// 		exec: (e)=>{

		// 			if(e.direction == 1 || this.isResized == false) {
		// 				this.$refs.splitedText.animateIn()
		// 			} else {
		// 				this.$refs.splitedText.animateOut()
		// 			}

		// 			this.isResized = true
		// 		}
		// 	})
		// }

		_bind () {
			super._bind()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

		_resize () {
			super._resize()

			this.isResized = false

			this.boundsAnim = {
				top: this.bounds.top - Globals.height,
				bottom: this.bounds.top + this.bounds.height
			}

			this.initTimeline()

			// this._points()
		}

	}

	export default PoliticalPresentation

</script>

<style lang="stylus" scoped>

	@import '../../../theme/variables'
	@import '../../../theme/utils'

	.political-presentation
		width 100%
		position relative
		overflow hidden
		padding-top 5vh

		+break(xs)
			padding 0 30px

		.wrap-text
			height 60vh
			width 100%
			display flex
			justify-content center
			will-change transform

			.splited-text
				width 50vw
				text-align center

				+break(xs)
					width 100vw

		.badge
			position absolute
			width 18vw

			img
				width 100%

			+break(xs)
				width 100px
			
			&-1
				top 25vh
				right 5vw

				+break(xs)
					right -50px
			
			&-2
				top 1vh
				left 2vw

				+break(xs)
					bottom -20px
					left -40px


</style>


// WEBPACK FOOTER //
// political-presentation.vue?457df5f4